// withRouter HOC compatibility for React Router v7
import { useLocation, useNavigate, useParams } from 'react-router-dom'

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()
    
    // React Router v7 uses navigate instead of history
    const history = {
      push: (path) => navigate(path),
      replace: (path) => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
      location
    }
    
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        location={location}
        navigate={navigate}
        params={params}
        history={history}
        match={{ params }}
      />
    )
  }

  return ComponentWithRouterProp
}
